<template>
  <div class="pickedStaff">
    <van-nav-bar :title="subHead" left-arrow @click-left="goBack" />
    <van-cell-group :title="`联系人：${list.organizer.length}人`">
      <van-cell
        v-for="(item) in list.organizer"
        :key="item.id"
        clickable
      >
        <template #title>
          <div class="title">
            <svg-icon icon-class="staff_avatar" style="font-size: 0.35rem" />
            <div class="value">
              <div class="name">
                <div>{{ item.attendee }}</div>
                <!-- <div class="sign" :style="`border: 1px solid ${item.signStatus ? zh.zhCN.signStatus[item.signStatus][1] : ''};`">
                  {{ item.signStatus ? zh.zhCN.signStatus[item.signStatus][0] : '' }}
                </div> -->
              </div>
              <span class="department">{{ item.company }}</span>
            </div>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group :title="`内部参会人：${list.inners.length}人`">
      <van-cell
        v-for="(item) in list.inners"
        :key="item.id"
        clickable
      >
        <template #title>
          <div class="title">
            <svg-icon icon-class="staff_avatar" style="font-size: 0.35rem" />
            <div class="value">
              <div class="name">
                <div>{{ item.attendee }}</div>
                <div
                  class="sign"
                 :style="`border: 1px solid ${item.signStatus ? zh.zhCN.signStatus[item.signStatus][1] : ''}; color: ${item.signStatus ? zh.zhCN.signStatus[item.signStatus][1] : ''}`"
                 >
                  {{ item.signStatus ? zh.zhCN.signStatus[item.signStatus][0] : '' }}
                </div>
              </div>
              <span class="department">{{ item.company }}{{ item.department }}</span>
            </div>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group :title="`外部参会人：${list.outers.length}人`">
      <van-cell
        v-for="(item) in list.outers"
        :key="item.id"
        clickable
      >
        <template #title>
          <div class="title">
            <svg-icon icon-class="staff_avatar" style="font-size: 0.35rem" />
            <div class="value">
              <div class="name">
                <div>{{ item.attendee }}</div>
                <div
                  class="sign"
                 :style="`border: 1px solid ${item.signStatus ? zh.zhCN.signStatus[item.signStatus][1] : ''}; color: ${item.signStatus ? zh.zhCN.signStatus[item.signStatus][1] : ''}`"
                 >
                  {{ item.signStatus ? zh.zhCN.signStatus[item.signStatus][0] : '' }}
                </div>
              </div>
              <span class="department">{{ item.company }}{{ item.department }}</span>
            </div>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>

export default {
  name: 'Attendees',
  data() {
    return {
      list: [],
      subHead: ''
    };
  },
  created() {
    const { title, list } = this.$route.query;
    this.subHead = title;
    this.list = JSON.parse(list);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.pickedStaff {
  .header {
    height: 0.44rem;
    font-size: 0.17rem;
    font-weight: 400;
    line-height: 0.24rem;
    color: #333333;
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.135rem;
    .confirm {
      color: #3B86FF;
    }
  }
  .title {
    display: flex;
    align-items: center;
    .value {
      display: flex;
      flex-direction: column;
      margin-left: 0.08rem;
      .name {
        font-size: 0.17rem;
        font-weight: 400;
        //line-height: 0.24rem;
        color: #001833;
        display: flex;
        align-items: center;

        .sign {
          // background: rgba(80, 196, 79, 0.1);
          // border: 1px solid #50C44F;
          opacity: 1;
          border-radius: 27px;
          font-size: 0.08rem;
          height: 0.15rem;
          font-family: PingFang SC;
          // color: #50C44F;
          margin-left: 0.1rem;
          padding: 0 0.07rem;
          display: flex;
          align-items: center;
        }

        .unsign {
          border: 1px solid #919191;
          opacity: 1;
          border-radius: 27px;
          font-size: 0.08rem;
          height: 0.15rem;
          font-family: PingFang SC;
          color: #919191;
          margin-left: 0.1rem;
          padding: 0 0.07rem;
          display: flex;
          align-items: center;
        }
      }
      .department {
        font-size: 0.14rem;
        font-weight: 400;
        line-height: 0.2rem;
        color: #333333;
      }

    }
  }
}
</style>
